import { makeStyles, Grid, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  plus: {
    color: theme.palette.primary.main,
    marginRight: theme.spacing(1.5),
  },
  title: {
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(2.5),
  },
  row: {
    "&:not(:last-child)": {
      borderBottom: "1px solid #DFE0EB",
    },
    padding: `${theme.spacing(2.5)}px ${theme.spacing(5)}px`,
    cursor: "pointer",
  },
  value: {
    color: "#9FA2B4",
  },
}));

export const Help = ({ title, rows }) => {
  const classes = useStyles();

  return (
    <Grid>
      <Typography variant="h4" className={classes.title}>
        {title}
      </Typography>
      {rows.map((row, i) => (
        <Grid
          container
          key={i}
          alignItems="center"
          className={classes.row}
          item
          sm={8}
          onClick={row.onClick}
        >
          <Grid item sm={9}>
            <Typography variant="body1">
              <Typography component="span" variant="h4" className={classes.plus}>
                +
              </Typography>
              {row.label}
            </Typography>
          </Grid>
          {row.value ? (
            <Grid>
              <Typography variant="body1" className={classes.value}>
                {row.value}
              </Typography>
            </Grid>
          ) : null}
        </Grid>
      ))}
    </Grid>
  );
};
